import PropTypes from "prop-types"
import styled from "styled-components"

import { Box, Flex, Typography } from "components/common/index"
import { IS_GE_CHECKOUT, IS_NA } from "helpers/application"

const Wrapper = styled(Flex).attrs((props) => ({
  bg: "white",
  mt: -2,
  p: "0 14px 24px 6px",
  ...props,
}))`
  ${({ theme }) => `
    justify-content: center;
    ${theme.mediaQueries.tablet`
      padding: 0;
    `}
  `}
  ${(props) =>
    props.showBorder &&
    `
    border-bottom: 1px solid ${props.theme.colors.grey[20]};
    ${props.theme.mediaQueries.tablet`
      border-top: 1px solid ${props.theme.colors.grey[20]};
    `}
  `}
`
const IconBlock = styled(Box)`
  ${({ theme }) => `
    margin-bottom: 10px;
    flex-basis: 20%;
    text-align: center;
    &:hover,
    &:focus,
    &:active {
      color: ${theme.colors.primary};
    }
    ${theme.mediaQueries.tablet`
      flex-basis: 16.6667%;
      margin-bottom: 0;
      padding-bottom: 10px;
    `}
  `}
`

const IconImage = styled(Box).attrs((props) => ({
  as: "img",
  width: "40px",
  ...props,
}))`
  margin: 10px auto;
  height: 50px;
`

const IconText = styled(Typography).attrs(() => ({
  as: "p",
}))`
  ${({ theme }) => `
    color: ${theme.colors.black};
    font-size: 9px;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 12px;
    margin: 0;
    text-transform: uppercase;
    ${theme.mediaQueries.tablet`
      font-size: 12px;
      line-height: 15px;
    `}
    ${theme.mediaQueries.desktop`
      line-height: 17px;
      padding: 0 32px;
    `}
  `}
`

const Perks = ({
  hasDiamondSelector,
  hasFreeResizing,
  showBorder,
  showDaysReturn,
  productType,
  wrapperStyle,
}) => {
  const is_na = IS_NA()
  const is_ge_checkout = IS_GE_CHECKOUT()
  return (
    <Wrapper contain showBorder={showBorder} {...wrapperStyle}>
      <IconBlock>
        <IconImage
          alt={hasDiamondSelector ? "Free Express Shipping" : "Free Shipping"}
          className="lazyload"
          data-src={
            hasDiamondSelector
              ? require("images/layout/footer/perks/free-express.svg")
              : require("images/layout/footer/perks/freeshipping.svg")
          }
          src={require("images/icons/jewlr.gif")}
          width={hasDiamondSelector ? "53px" : "40px"}
        />
        <IconText>
          {hasDiamondSelector ? "Free Express Shipping" : "Free Shipping"}
        </IconText>
      </IconBlock>

      {is_na && hasFreeResizing && (
        <IconBlock>
          <IconImage
            alt="Free Resizing"
            className="lazyload"
            data-src={require("images/layout/footer/perks/freeresizing.svg")}
            src={require("images/icons/jewlr.gif")}
          />
          <IconText>
            Free Resizing
            {productType}
          </IconText>
        </IconBlock>
      )}
      {showDaysReturn && (
        <IconBlock
          display={{
            _: is_na && hasFreeResizing ? "none" : "block",
            tablet: "block",
          }}
        >
          <IconImage
            alt={`${is_ge_checkout ? "30" : "99"} Day Returns`}
            className="lazyload"
            data-src={require("images/layout/footer/perks/99dayreturn.svg")}
            src={require("images/icons/jewlr.gif")}
          />
          <IconText>{is_ge_checkout ? "30" : "99"}-Day Returns</IconText>
        </IconBlock>
      )}
      <IconBlock>
        <IconImage
          alt={hasDiamondSelector ? "Lifetime Warranty" : "One-Year Warranty"}
          className="lazyload"
          data-src={
            hasDiamondSelector
              ? require("images/layout/footer/perks/lifetime-warranty.svg")
              : require("images/layout/footer/perks/warranty.svg")
          }
          src={require("images/icons/jewlr.gif")}
        />
        <IconText>
          {hasDiamondSelector ? "Lifetime Warranty" : "One-Year Warranty"}
        </IconText>
      </IconBlock>

      <IconBlock>
        <IconImage
          alt="Made In USA & Canada"
          className="lazyload"
          data-src={require("images/layout/footer/perks/madein.svg")}
          src={require("images/icons/jewlr.gif")}
        />
        <IconText>
          Made in
          <br /> North America
        </IconText>
      </IconBlock>
    </Wrapper>
  )
}

Perks.propTypes = {
  hasDiamondSelector: PropTypes.bool,
  hasFreeResizing: PropTypes.bool,
  productType: PropTypes.string,
  showBorder: PropTypes.bool,
  showDaysReturn: PropTypes.bool,
  wrapperStyle: PropTypes.object,
}

export default Perks
